module.exports = __webpack_public_path__ + "static/media/2014.1beda70a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/about/2014.png
// module id = 600
// module chunks = 0